(() => {
  const initializeMobileMenuLinks = () => {
    const menuButton = document.querySelector("[data-menu-button]");
    const mobileMenu = document.querySelector("[data-mobile-menu]");

    if (!menuButton || !mobileMenu) return;

    mobileMenu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        mobileMenu.classList.add("hidden");
        menuButton.setAttribute("aria-expanded", "false");
      });
    });
  };

  const initializeNewsletter = () => {
    document.querySelectorAll("[data-newsletter-form]").forEach((form) => {
      const status = form.parentElement.querySelector("[data-newsletter-status]");

      form.addEventListener("submit", (event) => {
        event.preventDefault();
        form.reset();

        if (status) {
          status.textContent = "Thanks for subscribing. Watch your inbox for the next Cube story.";
        }
      });
    });
  };

  const initializeBlogFilters = () => {
    const filterButtons = document.querySelectorAll("[data-blog-filter]");
    const articleCards = document.querySelectorAll("[data-blog-card]");
    const visibleCount = document.querySelector("[data-blog-visible-count]");

    if (!filterButtons.length || !articleCards.length) return;

    const updateFilter = (filter) => {
      let count = 0;

      articleCards.forEach((card) => {
        const categories = (card.dataset.blogCategories || "").split(/\s+/);
        const matches = filter === "all" || categories.includes(filter);
        card.hidden = !matches;
        if (matches) count += 1;
      });

      filterButtons.forEach((button) => {
        button.setAttribute("aria-pressed", String(button.dataset.blogFilter === filter));
      });

      if (visibleCount) {
        visibleCount.textContent = `${count} ${count === 1 ? "story" : "stories"}`;
      }
    };

    filterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        updateFilter(button.dataset.blogFilter || "all");
      });
    });
  };

  const initializeArticleToc = () => {
    const toc = document.querySelector("[data-blog-toc]");
    const tocLinks = document.querySelector("[data-blog-toc-links]");
    const content = document.querySelector("[data-article-content]");

    if (!toc || !tocLinks || !content) return;

    const headings = [...content.querySelectorAll("h2")].filter((heading) => heading.textContent.trim()).slice(0, 8);

    if (!headings.length) {
      toc.hidden = true;
      return;
    }

    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = heading.textContent
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-|-$/g, "");
      }

      const link = document.createElement("a");
      link.className = "blog-toc__link";
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      tocLinks.append(link);
    });
  };

  const initializeCopyLink = () => {
    document.querySelectorAll("[data-copy-link]").forEach((button) => {
      const defaultLabel = button.querySelector("[data-copy-label]")?.textContent || "Copy link";

      button.addEventListener("click", async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          const label = button.querySelector("[data-copy-label]");
          if (label) label.textContent = "Link copied";
          window.setTimeout(() => {
            if (label) label.textContent = defaultLabel;
          }, 1800);
        } catch {
          window.prompt("Copy this article link:", window.location.href);
        }
      });
    });
  };

  const initialize = () => {
    initializeMobileMenuLinks();
    initializeNewsletter();
    initializeBlogFilters();
    initializeArticleToc();
    initializeCopyLink();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
